<template>
  <div class="freight-rate">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="方案名称：">
          <el-input v-model="searchForm.name" placeholder="方案名称" style="width: 150px;" />
        </el-form-item>
        <el-form-item label="按保险公司：">
          <el-select 
            v-model="searchForm.insurance_type" 
            placeholder="请选择保险公司" 
            filterable
            clearable
            style="width: 220px;"
          >
            <el-option
              v-for="item in insuranceOptions"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="searchForm.risk_type" 
            placeholder="承保险种" 
            clearable
            style="width: 100px;"
          >
            <el-option
              v-for="item in riskTypeOptions"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="searchForm.policy_type" 
            placeholder="保单类型" 
            clearable
            style="width: 100px;"
          >
            <el-option
              v-for="item in policyTypeOptions"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="按产品类别：">
          <el-select 
            v-model="searchForm.product_id" 
            placeholder="请选择产品" 
            filterable
            clearable
            style="width: 150px;"
          >
            <el-option
              v-for="item in productOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">全部</el-button>
        </el-form-item>
      </el-form>
      
      <div class="toolbar-right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">创建价格方案</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      :height="tableHeight"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="name" label="方案名称" width="180" />
      <el-table-column prop="product_name" label="匹配产品" width="150" />
      <el-table-column prop="insurance_type" label="保险公司" width="150">
        <template slot-scope="scope">
          {{ formatInsuranceType(scope.row.insurance_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="risk_type" label="承保险种" width="130">
        <template slot-scope="scope">
          {{ formatRiskType(scope.row.risk_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="policy_type" label="保单类型" width="90">
        <template slot-scope="scope">
          {{ formatPolicyType(scope.row.policy_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="commission_rate" label="佣金比例（%）" width="140" />
      <el-table-column prop="pay_channel" label="支付渠道" width="140">
        <template slot-scope="scope">
          {{ formatPayChannel(scope.row.pay_channel) }}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="保险费率(%)" width="100" align="right">
        <template slot-scope="scope">
          {{ formatRate(scope.row.rate) }}
        </template>
      </el-table-column>
      <el-table-column prop="max_coverage" label="最高限额（万元）" width="120" align="right">
        <template slot-scope="scope">
          {{ formatMaxCoverage(scope.row.max_coverage) }}
        </template>
      </el-table-column>
      <el-table-column prop="min_premium" label="最低保费" width="100" align="right" />
      <el-table-column prop="insurance_item" label="保险标的" width="140" show-overflow-tooltip />
      <el-table-column prop="deductible" label="免赔额约定" width="140" show-overflow-tooltip />
      <el-table-column prop="special_clauses" label="特别约定" width="140" show-overflow-tooltip />
      <el-table-column prop="extension_clauses" label="附加条款" width="140" show-overflow-tooltip />
      <el-table-column prop="warranty_against_cargo" label="不予承保说明" width="140" show-overflow-tooltip />
      <el-table-column prop="claim_service" label="保险理赔服务" width="140" show-overflow-tooltip />
      <el-table-column prop="created_at" label="创建时间" width="140">
        <template slot-scope="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="disabled" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
            {{ scope.row.disabled ? '禁用' : '正常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row, scope.$index)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.row, scope.$index)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button 
            type="text" 
            @click="handleToggleStatus(scope.row)"
            :class="scope.row.disabled ? 'success-text' : 'danger-text'"
          >
            {{ scope.row.disabled ? '启用' : '禁用' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />
    </div>

    <!-- 编辑弹窗 -->
    <SchemeEditDialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :form-data="currentRow"
      :is-view="isView"
      :scheme-type="'freight_rate'"
      @save="handleSaveSuccess"
    />
  </div>
</template>

<script>
import { 
  getSchemeList, 
  deleteScheme, 
  toggleSchemeStatus,
  getProductList,
  getInsuranceCompanyList 
} from '@/api/product'
import SchemeEditDialog from './SchemeEditDialog'
import { formatDate } from '@/utils'

export default {
  name: 'FreightRate',
  components: {
    SchemeEditDialog
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        name: '',
        insurance_type: '',
        risk_type: '',
        policy_type: '',
        product_id: ''
      },
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      // 选项数据
      insuranceOptions: [],
      riskTypeOptions: [
        { id: 1, text: '物流责任险' },
        { id: 2, text: '雇主责任险' },
        { id: 4, text: '财产基本险' },
        { id: 8, text: '财产综合险' },
        { id: 16, text: '公路运输险' },
        { id: 32, text: '公路货物运输定额险' },
        { id: 64, text: '第三者责任险' },
        { id: 128, text: '无车承运人责任险' },
        { id: 256, text: '健康险' }
      ],
      policyTypeOptions: [
        { id: 1, text: '电子保单' },
        { id: 2, text: '承保确认单' }
      ],
      productOptions: [],
      payChannelOptions: [
        { id: 1, text: '线上支付' },
        { id: 2, text: '线下支付' }
      ],
      // 弹窗相关
      dialogVisible: false,
      currentRow: null,
      isView: false,
      tableHeight: 600
    }
  },
  mounted() {
    this.calculateTableHeight()
    this.fetchInitialData()
    this.fetchTableData()
    window.addEventListener('resize', this.calculateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    // 计算表格高度
    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        this.tableHeight = windowHeight - 350
      })
    },

    // 获取初始数据
    async fetchInitialData() {
      try {
        const [productRes, insuranceRes] = await Promise.all([
          getProductList(),
          getInsuranceCompanyList()
        ])

        if (productRes && productRes.err_code === 0) {
          this.productOptions = productRes.rows || []
        }

        if (insuranceRes && insuranceRes.err_code === 0) {
          this.insuranceOptions = (insuranceRes.rows || []).map(item => ({
            id: item.id,
            text: item.name
          }))
        }
      } catch (error) {
        console.error('获取初始数据失败:', error)
      }
    },

    // 获取表格数据
    async fetchTableData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          calculate_type: 8, // 运费*费率类型
          page: this.pagination.page,
          rows: this.pagination.rows
        }

        // 清除空值
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const response = await getSchemeList(params)
        if (response && response.err_code === 0) {
          this.tableData = response.rows || []
          this.pagination.total = response.total || 0
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchTableData()
    },

    // 重置
    handleReset() {
      this.searchForm = {
        name: '',
        insurance_type: '',
        risk_type: '',
        policy_type: '',
        product_id: ''
      }
      this.pagination.page = 1
      this.fetchTableData()
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.rows = val
      this.pagination.page = 1
      this.fetchTableData()
    },

    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchTableData()
    },

    // 新增
    handleAdd() {
      this.currentRow = null
      this.isView = false
      this.dialogVisible = true
    },

    // 查看
    handleView(row, index) {
      this.currentRow = { ...row, index }
      this.isView = true
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row, index) {
      this.currentRow = { ...row, index }
      this.isView = false
      this.dialogVisible = true
    },

    // 删除
    handleDelete(id) {
      this.$confirm('您确认想要删除该产品方案吗？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteScheme({ id })
          if (response && response.err_code === 0) {
            this.$message.success('删除产品方案成功')
            this.fetchTableData()
          } else {
            this.$message.error(response?.err_msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      })
    },

    // 切换状态
    handleToggleStatus(row) {
      const action = row.disabled ? '启用' : '禁用'
      this.$confirm(`您确认想要${action}该方案吗？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await toggleSchemeStatus({
            id: row.id,
            disabled: !row.disabled
          })
          if (response && response.err_code === 0) {
            this.$message.success(`${action}成功`)
            this.fetchTableData()
          } else {
            this.$message.error(response?.err_msg || `${action}失败`)
          }
        } catch (error) {
          console.error(`${action}失败:`, error)
          this.$message.error(`${action}失败`)
        }
      })
    },

    // 保存成功回调
    handleSaveSuccess() {
      this.dialogVisible = false
      this.fetchTableData()
    },

    // 格式化函数
    formatDate(date) {
      return formatDate(date, 'YYYY-MM-DD HH:mm:ss')
    },

    formatRate(rate) {
      return rate ? (rate / 10000) + '%' : ''
    },

    formatMaxCoverage(coverage) {
      return coverage ? parseInt(coverage / 10000) : ''
    },

    formatInsuranceType(value) {
      const item = this.insuranceOptions.find(option => option.id === value)
      return item ? item.text : '还未选择'
    },

    formatRiskType(value) {
      const item = this.riskTypeOptions.find(option => option.id === value)
      return item ? item.text : '还未选择'
    },

    formatPolicyType(value) {
      const item = this.policyTypeOptions.find(option => option.id === value)
      return item ? item.text : '还未选择'
    },

    formatPayChannel(value) {
      const item = this.payChannelOptions.find(option => option.id === value)
      return item ? item.text : '还未选择'
    }
  }
}
</script>

<style scoped>
.freight-rate {
  padding: 20px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.search-form {
  flex: 1;
}

.toolbar-right {
  margin-left: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.success-text {
  color: #67c23a;
}

.danger-text {
  color: #f56c6c;
}
</style>